import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailDisplayInfo } from '../types';
import { AnimatedThumbnail } from './AnimatedThumbnail';
import { ThumbnailFrame } from './ThumbnailFrame';
import { ThumbnailSprite } from './ThumbnailSprite';

export type ThumbnailProps = ThumbnailDisplayInfo;

/**
 * Logger filmstrip thumbnail: bordered frame around a sprite cell.
 * Optional animation cycles every frame in the sheet (row-major, multi-row safe).
 */
export function Thumbnail({
  url,
  offset,
  metadata,
  animated = false,
  targetHeight = THUMBNAIL_HEIGHT,
}: ThumbnailProps) {
  if (animated) {
    return <AnimatedThumbnail url={url} metadata={metadata} targetHeight={targetHeight} />;
  }

  return (
    <ThumbnailFrame>
      <ThumbnailSprite
        url={url}
        metadata={metadata}
        frameIndex={offset}
        mode="px"
        targetHeight={targetHeight}
      />
    </ThumbnailFrame>
  );
}
